import { Grid } from '@mui/material'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import FormInput from 'components/FormInput'
import React, { useEffect } from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'

type MentalTreatmentGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const MentalTreatmentGroup: React.FC<MentalTreatmentGroupProps> = ({
  control,
  watch,
  setValue,
}) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  const hasMentalTreatment = watch('identificacaoAdolescente.tratamentoMental')

  useEffect(() => {
    if (hasMentalTreatment === 'N') {
      setValue('identificacaoAdolescente.tipoTratamentoMental', '')
      setValue('identificacaoAdolescente.instituicaoTratamentoMental', '')
    }
  }, [hasMentalTreatment, setValue])

  return (
    <>
      <Grid item lg={3} xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.tratamentoMental'
          label='Faz algum tratamento de saúde mental?'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields}
        />
      </Grid>
      {hasMentalTreatment === 'S' && (
        <>
          <Grid item lg={5} md={12}>
            <FormInput
              control={control}
              name='identificacaoAdolescente.tipoTratamentoMental'
              label='Tratamento'
              placeholder='Informe o tratamento'
              maxLength={60}
            />
          </Grid>
          <Grid item lg={4} md={12}>
            <FormInput
              control={control}
              name='identificacaoAdolescente.instituicaoTratamentoMental'
              label='Instituição de tratamento mental'
              placeholder='Informe a instituição'
              maxLength={60}
            />
          </Grid>
        </>
      )}
    </>
  )
}
